<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZAu9AN/tc-custom/9780061734106.jpg?1731838249880" alt="This image is the cover for the book 24 Declassified: Storm Force, Jack Bauer Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">24 Declassified: Storm Force, Jack Bauer Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>Still reeling but rebuilding after Katrina's fury, New Orleans braces for another major hurricane heading her way. But a far greater threat is looming on the horizon—a manmade terror storm that will dwarf the destructive force of anything Mother Nature could have devised.</p><p>Following a tip, agent Jack Bauer has come to the Big Easy—and watches helplessly as two prime players representing America's most dangerous Latin American adversaries fall in a surprising hail of gunfire. With winds rapidly approaching gale force, the rogue CTU operative must now follow the blood trail to a completely unexpected source. Because in less than 24 hours, a ruthless enemy hiding among "friends" plans to take out the already damaged Crescent City—and deliver a staggering blow from which the U.S. "Satan" may never recover.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Jacobs
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36b2aeac